<template>
    <iv-modal
        :mask-closable="false"
        :title="title"
        :width="width"
        :closable="false"
        v-model="sources.shown"
        @on-cancel="onCancel"
    >
      <template v-if="value && sources.formData">
          <iv-form :model="sources.formData" :label-width="100" label-position="left">
            <iv-row :gutter="24" style="margin-bottom: 20px;">
                <iv-col span="22">
                    <span style="color:#3C3C3C;font-weight:bold;font-size: 15px;">
                      {{ !!sources.formData.title ? sources.formData.title : "" }}</span>
                    <a class="item_edit" @click="onOriginClick(sources.formData)">
                      <iv-icon type="md-open" size="16" style="vertical-align:text-bottom" />
                    </a>
                    <br>
                    <span
                      style="margin-left:10px;">(爬取时间：{{  !!sources.formData.crawlTime ? sources.formData.crawlTime : ""}})</span>
                </iv-col>
                <iv-col span="2" v-if="type == 'edit'">
                    <iv-button v-if="!editabled"  size="small" class="pull-right" type="primary" @click="gotoStatus('edit')">编辑
                    </iv-button>
                    <template v-else>
                      <iv-button :loading="loader[LISTED_PUNISHMENT+'saveDetail']" class="pull-right" size="small" style="margin-left:20px" type="primary" @click="save">完成编辑
                      </iv-button>
                      <iv-button :disabled="loader[LISTED_PUNISHMENT+'saveDetail']" class="pull-right" size="small" @click="gotoStatus('view')">取消编辑
                      </iv-button>
                    </template>
                </iv-col>
              </iv-row>
            <div style="position: relative">
              <iv-spin size="large" fix v-if="loader[LISTED_PUNISHMENT+'saveDetail']"></iv-spin>
              <iv-row :gutter="24">
                  <iv-col span="8">
                      <iv-form-item label="公司罚款：" prop="institutionalFines">
                      <iv-input :disabled="!editabled" type="text" v-model="sources.formData.institutionalFines">
                      </iv-input>
                      </iv-form-item>
                  </iv-col>
                  <iv-col span="8">
                      <iv-form-item label="个人罚款：" prop="personalFines">
                      <iv-input :disabled="!editabled" type="text" v-model="sources.formData.personalFines">
                      </iv-input>
                      </iv-form-item>
                  </iv-col>
                  <iv-col span="8">
                      <iv-form-item label="没收违法所得：" prop="confiscateIllegalGains">
                      <iv-input :disabled="!editabled" type="text" v-model="sources.formData.confiscateIllegalGains">
                      </iv-input>
                      </iv-form-item>
                  </iv-col>
              </iv-row>
              <iv-row :gutter="24">
                  <iv-col span="24">
                    <iv-form-item label="处罚依据：" prop="basisOfPunishment">
                        <iv-input :disabled="!editabled" type="textarea" :rows="3"
                        v-model="sources.formData.basisOfPunishment"></iv-input>
                    </iv-form-item>
                  </iv-col>
              </iv-row>
              <iv-row :gutter="24">
                  <iv-col span="24">
                    <iv-form-item label="处罚类别：" prop="punishCategory">
                        <p>{{sources.formData.punishCategory}}</p>
                    </iv-form-item>
                  </iv-col>
              </iv-row>
              <iv-row :gutter="12">
                  <iv-col span="24">
                    <iv-form-item label="处罚内容：" prop="punishContent">
                        <iv-input :disabled="!editabled" type="textarea" :rows="3" v-model="sources.formData.punishContent">
                        </iv-input>
                    </iv-form-item>
                  </iv-col>
                  <iv-col span="24">
                    <iv-form-item label="处罚事实：" prop="illegalFact">
                        <iv-input :disabled="!editabled" type="textarea" :rows="3" v-model="sources.formData.illegalFact">
                        </iv-input>
                    </iv-form-item>
                  </iv-col>
              </iv-row>
            </div>
          </iv-form>
          <template v-if="value && type=='edit'">
              <iv-row :gutter="24" >
                  <hr class="adm-hr" style="margin: 0 12px 10px;" />
                  <iv-col span="24">
                      <p style="font-weight:bold;font-size: 15px;margin-bottom: 10px;">修改指标及评分</p>
                  </iv-col>
                  <iv-col span="6">
                      <span style="line-height: 25px;">二级指标：</span>
                      <iv-select v-model="sources.formData.secondTargetNum" size="small" style="width:100px" @on-change="refreshthirdTarget({ secondTargetNum : sources.formData.secondTargetNum, targetType:sources.formData.targetType });UpdateThirdTargetNum()">
                          <iv-option v-for="(item,i) in options.secondTargets" :value="item.id" :key="i">{{ item.name }}</iv-option>
                      </iv-select>
                  </iv-col>
                  <iv-col span="8">
                      <span style="line-height: 25px;">三级指标：</span>
                      <iv-select v-model="sources.formData.thirdTargetNum" size="small" style="width:180px" @on-change="UpdateThirdTargetNum()">
                          <iv-option v-for="(item,i) in options.thirdTargets" :value="item.id" :key="i">{{ item.name }}</iv-option>
                      </iv-select>
                  </iv-col>
              </iv-row>
              <iv-row style="margin-top:30px">
                  <iv-col span="24">
                      <span style="line-height: 25px;">分析维度：</span>
                      <iv-table
                          border
                          class="adm-table"
                          :columns="columns"
                          :data="list.dimensionInfo">
                      </iv-table>
                  </iv-col>
              </iv-row>
          </template>
          <iv-button type="text" size="large" slot="footer" @click="onCancel">关闭</iv-button>
      </template>
    </iv-modal>
</template>
<script>
import Vue from "vue";
import { BusinessError, RequestError, isNumber} from '@/utils/';
import ModelMixin from "@/mixins/Model.mixin";
import LoaderMixin from "@/mixins/Loader.mixin";
import contact from "@/utils/contact";
import ListedTargetModel from "@/models/ListedTargetModel";
import ListedPunishmentModel  from '@/models/ListedPunishmentModel';

const FORM_NAME = `${LISTED_PUNISHMENT}Form`;
const LISTED_TARGET = ListedTargetModel.ModelName;
const LISTED_PUNISHMENT = ListedPunishmentModel.ModelName;

function columns(vm){
        return  [
            {
                title: "分析维度",
                key: "dimension",
                align: "center",
                minWidth: 60,

            },
            {
                title: "得分",
                key: "abbreviation",
                align: "center",
                minWidth: 120,
                 render(h, params){
                    var dimensionScore = params.row.dimensionScore ? params.row.dimensionScore : 0;
                    const $inputNumber = <iv-input-number min={0} max={params.row.dimensionWeight} v-model={dimensionScore} onInput={ ()=>vm.dimension(params.row, dimensionScore )}></iv-input-number>
                    return <div>{ $inputNumber }</div>
                }
            },
            {
                title: "评分说明",
                key: "dimensionRuleExplain",
                align: "center",
                minWidth: 150,
            }
        ]
}
export default {
    mixins: [
        LoaderMixin(LISTED_TARGET,LISTED_PUNISHMENT,LISTED_PUNISHMENT+'saveDetail'),
        ModelMixin({
            contact,
            models: [ListedTargetModel,ListedPunishmentModel],
        }),
    ],
    props: {
        width: {
            type: [String, Number],
            default: "800",
        },
        value: {
            type: Object,
            default: null,
        },
        title: {
            type: String,
            default: "处罚详情"
        },
        type: {
            type: String,
            default: "read" //可选：read, edit；read为详情，edit为编辑
        },
        shown: Boolean,
    },
    watch: {
        shown(val) {
            this.sources.shown = val;
            this.list = {
               dimensionInfo: []
            }
            if(!val){
              this.sources.formData = null
            }else{
              const { secondTargetNum, targetType } = (this.value||{})
              this.refreshsecondTarget({ targetType })
              this.refreshthirdTarget({ secondTargetNum, targetType })
            }
        },
        async value(val) {
            this.sources.formData = val
            this.list.dimensionInfo = val.dimensionInfo
        },
    },
    data() {
        return {
            FORM_NAME,
            LISTED_TARGET,
            LISTED_PUNISHMENT,
            columns: columns(this),
            options: {
                secondTargets:[],
                thirdTargets:[]
            },
            sources: {
                //双向绑定字段
                shown: false,
                formData: null
            },
            list:{
               dimensionInfo: []
            },
            editabled:false
        };
    },
    methods: {
        async refreshfirstTarget(params = this.$route.params){
            const firstTarget = await this.$$active(LISTED_TARGET, 'firstTarget',{ type:'listed', ...params })
            if(firstTarget)  this.options.firstTargets = firstTarget.data
        },
        async refreshsecondTarget(params = this.$route.params){
            const secondTarget = await this.$$active(LISTED_TARGET, 'secondTarget',{ type:'listed', ...params })
            if(secondTarget)  this.options.secondTargets = secondTarget.data
        },
        async refreshthirdTarget(params = this.$route.params){
            const thirdTarget = await this.$$active(LISTED_TARGET, 'thirdTarget',{ type:'listed', ...params })
            if(thirdTarget)  this.options.thirdTargets = thirdTarget.data
        },
        async UpdateThirdTargetNum(){
            if(!this.sources.formData.thirdTargetNum || this.sources.formData.thirdTargetNum == '待定') return
            let data = {
                id: this.sources.formData.id,
                thirdTargetNum: this.sources.formData.thirdTargetNum
            }
            const result = await this.$$active(LISTED_PUNISHMENT, 'thirdTargetNum',data)
            this.list = result.data[0]
        },
        onCancel() {
            this.$emit('refresh')
            this.hide();
        },
        async save(){
            // const validate = await this.$refs[FORM_NAME].validate();
            // if (!validate) {
            //     this.$$warning('表单验证不通过，请继续填写。');
            //     return Promise.reject(new Error('表单验证不通过，请继续填写。'));
            // }
            // this.options.validation.errors.value = ""
            const result = await this.$$active(LISTED_PUNISHMENT, 'saveDetail', this.sources.formData)

            if([BusinessError, RequestError, Error].indexOf(result.constructor) == -1){
                this.$$success(`保存成功`)
                // this.hide();
                this.gotoStatus('view')
            }
            this.$emit('refresh');
        },
        hide() {
            this.sources.shown = false;
            this.gotoStatus('view')
            this.$emit("shown-changed", this.sources.shown);
        },
        async dimension(item,score){
            if(score == null)return;
            var data = {
                id: this.sources.formData.id,
                dimensionInfo : [
                   {
                     dimensionId: item.dimensionId,
                     dimensionScore: score
                   }
                ]
            }
            const result = await this.$$active(LISTED_PUNISHMENT, 'dimension',data)
        },
        gotoStatus(status){
            switch(status){
            case 'edit':
                this.editabled = true;
                break;
            case 'view':
                this.editabled = false;
                this.sources.formData = Object.assign({},this.value)
                break;
            }
        },
        onOriginClick(item){
          let routerJump = this.$router.resolve({path: '/punishment/preview' })
          const { title,content,originUrl } = item
          const href = originUrl ? originUrl : routerJump.href
          window.punishmentPreviewWindow = window.open(href, originUrl?'__brank':'punishmentPreviewWindow')
          localStorage.setItem("PUNISHMENT_PREVIEW", JSON.stringify({ title, content }))
          window.punishmentPreviewWindow.location.reload()
        }
    },
};
</script>
<style lang="scss" scoped>
.adm-content-item {
  font-size: 12px;
  padding: 5px 10px;
  color: #999999;
  .search-text {
    color: #e94949;
  }
  &__title {
    font-size: 12px;
    margin-bottom: 0.5em;
    h5{
      display: inline;
    }
    small {
      color: #aaa;
      font-weight: normal;
      margin-left: 0.625em;
    }
    .item_edit {
      color: #2d8cf0;
      &:hover {
        cursor: pointer;
      }
    }
  }
}
</style>
